export const OPEN_RTK_MODAL = 'OPEN_RTK_MODAL';
export const CLOSE_RTK_MODAL = 'CLOSE_RTK_MODAL';

function openRtkModal(id) {
  return {
    type: OPEN_RTK_MODAL,
    isRtkModalShown: true,
    rtkId: id,
  };
}

function closeRtkModal() {
  return {
    type: CLOSE_RTK_MODAL,
    isRtkModalShown: false,
  };
}

export function showRtkModal(id) {
  return (dispatch) => {
    dispatch(openRtkModal(id));
  };
}

export function hideRtkModal() {
  return (dispatch) => {
    dispatch(closeRtkModal());
  };
}
